import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  // boxShadow: theme.shadows[1], // Optional: Add shadow
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.1rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}));

export const ExceptionButtonRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  width: '50%',
}));

export const LateArrivalButton = styled(Button)(({ theme }) => ({
  flex: 1,
  backgroundColor: '#FFF8E1', // Light yellow background
  color: '#D89614', // Gold/Dark Yellow text
  fontWeight: 600,
  fontSize: '1rem',
  textTransform: 'none',
  padding: theme.spacing(1.5),
  borderRadius: '8px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#FFECB3', 
    boxShadow: 'none',
  },
}));

export const AbsentButton = styled(Button)(({ theme }) => ({
  flex: 1,
  backgroundColor: '#FFEBEE', // Light red/pink background
  color: '#D32F2F', // Red text
  fontWeight: 600,
  fontSize: '1rem',
  textTransform: 'none',
  padding: theme.spacing(1.5),
  borderRadius: '8px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#FFCDD2',
    boxShadow: 'none',
  },
}));